import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { BookOpen, Layers, Network, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { topicsAtom } from '@/lib/store';

export function AppSidebar() {
  const topics = useAtomValue(topicsAtom);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <aside className="flex w-64 shrink-0 flex-col border-r border-slate-800 bg-slate-900 text-slate-200">
      <div className="border-b border-slate-800 p-3">
        <Button size="sm" className="w-full" onClick={() => navigate('/?new=1')}>
          <Plus className="mr-2 h-4 w-4" />
          New topic
        </Button>
        <Link
          to="/event-bank"
          className={cn(
            'mt-2 flex items-center gap-2 rounded-md px-3 py-2 text-sm hover:bg-slate-800',
            location.pathname === '/event-bank' && 'bg-slate-800 ring-1 ring-slate-600',
          )}
        >
          <Network className="h-3.5 w-3.5 shrink-0 text-slate-400" />
          <span className="font-medium">Event Bank</span>
        </Link>
        <Link
          to="/context-repository"
          className={cn(
            'mt-2 flex items-center gap-2 rounded-md px-3 py-2 text-sm hover:bg-slate-800',
            location.pathname === '/context-repository' && 'bg-slate-800 ring-1 ring-slate-600',
          )}
        >
          <BookOpen className="h-3.5 w-3.5 shrink-0 text-slate-400" />
          <span className="font-medium">Context Repository</span>
        </Link>
      </div>

      <div className="flex-1 overflow-y-auto p-3">
        <p className="mb-2 px-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Topics</p>
        {topics.length === 0 ? (
          <p className="px-1 text-[11px] text-slate-500">No topics yet.</p>
        ) : (
          <div className="space-y-1">
            {topics.map((t) => {
              const active = location.pathname === `/topics/${t.id}`;
              const count = t.sourceCount ?? 0;
              return (
                <Link
                  key={t.id}
                  to={`/topics/${t.id}`}
                  className={cn('block rounded-md px-3 py-2 hover:bg-slate-800', active && 'bg-slate-800 ring-1 ring-slate-600')}
                >
                  <span className="flex items-center gap-2">
                    <Layers className="h-3.5 w-3.5 shrink-0 text-slate-400" />
                    <span className="truncate text-sm font-medium">{t.title}</span>
                  </span>
                  <span className="ml-5 block text-[11px] text-slate-400">
                    {count} source{count === 1 ? '' : 's'}
                  </span>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </aside>
  );
}
